<template>
  <SDirectionSelection
    :getArrivalPlace="getArrivalPlace"
    :getDeparturePlace="getDeparturePlace"
    :getIsArrivalPlaceFilled="!!getIsArrivalPlaceFilled"
    :getIsDeparturePlaceFilled="!!getIsDeparturePlaceFilled"
    :commune-coordinates="getCommuneCoordinatesForMap"
    :is-night-cards-support="isNightCardsSupport"
    :ops-zone-map-fill="opsZoneMapFill"
    :ops-zone-map-stroke="opsZoneMapStroke"
    :commune-map-fill="communeMapFill"
    :commune-map-stroke="communeMapStroke"
    @setRideType="data => $store.commit('booking/setRideType', data)"
    @populateOpsZone="data => $store.commit('opsZone/populateOpsZone', data)"
    @setDeparturePlace="data => setDeparturePlace(data)"
    @setArrivalPlace="data => setArrivalPlace(data)"
    @clearDeparturePlace="$store.commit('booking/clearDeparturePlace')"
    @clearArrivalPlace="$store.commit('booking/clearArrivalPlace')"
    @clearBookingForm="clearBookingForm"
    @trackGtmEventFromInput="onTrackEventFromInput"
    @trackGtmEventToInput="onTrackEventToInput"
    @trackGtmEventSelectDeparturePlace="onSelectDeparturePlace"
    @trackGtmEventSelectArrivalPlace="onSelectArrivalPlace"
  />
</template>

<script lang="ts">
export default {
  name: 'DirectionSelection',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { SDirectionSelection } from '@slg/web-customer-shared';
import { useStore, useGtm } from '@/composables';

const emit = defineEmits(['clearBookingRequestError']);
const store = useStore();
const { trackGtmEvent } = useGtm();

const getArrivalPlace = computed(() => store.getters['booking/getArrivalPlace']);
const getDeparturePlace = computed(() => store.getters['booking/getDeparturePlace']);
const getIsArrivalPlaceFilled = computed(() => store.getters['booking/isArrivalPlaceFilled']);
const getIsDeparturePlaceFilled = computed(() => store.getters['booking/isDeparturePlaceFilled']);
const isOpsZoneSelected = computed(() => store.getters['opsZone/isOpsZoneSelected']);
const getUserProfile = computed(() => store.getters['auth/getUserProfile']);
const getAppConfig = computed(() => store.getters['common/getAppConfig']);
const getCommuneCoordinatesForMap = computed(() => getUserProfile.value?.communeCoordinates || []);
const isNightCardsSupport = computed(() => !!(getAppConfig.value && getAppConfig.value.isNightCardsSupport));
const opsZoneMapFill = computed(() => (getAppConfig.value && getAppConfig.value.opsZoneMapFill) || '');
const opsZoneMapStroke = computed(() => (getAppConfig.value && getAppConfig.value.opsZoneMapStroke) || '');
const communeMapFill = computed(() => (getAppConfig.value && getAppConfig.value.communeMapFill) || '');
const communeMapStroke = computed(() => (getAppConfig.value && getAppConfig.value.communeMapStroke) || '');

function onSelectDeparturePlace() {
  trackGtmEvent('Select Pick Up address button click', 'Button', 'Click', '');
}

function onSelectArrivalPlace() {
  trackGtmEvent('Select Drop Off address button click', 'Button', 'Click', '');
}

function setDeparturePlace(data: unknown) {
  store.commit('booking/setDeparturePlace', data);
  emit('clearBookingRequestError');
}

function setArrivalPlace(data: unknown) {
  store.commit('booking/setArrivalPlace', data);
  emit('clearBookingRequestError');
}

function clearBookingForm() {
  if (isOpsZoneSelected.value) {
    store.commit('booking/clearDates');
    store.commit('booking/clearOptions');
    store.commit('opsZone/clearOpsZone');
  }
}

function onTrackEventFromInput() {
  trackGtmEvent('From input click', 'Input', 'Click', 'Open dialog with map and poi list');
  trackGtmEvent('Pop-up with map and poi list opened', 'Pop-up', 'Opened', '');
}

function onTrackEventToInput() {
  trackGtmEvent('To input click', 'Input', 'Click', 'Open dialog with map and poi list');
  trackGtmEvent('Pop-up with map and poi list opened', 'Pop-up', 'Opened', '');
}
</script>
